var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RunConfig_1;
import { JsonSchemaV2, JSON, JsonDiscriminatorProperty } from '@symon-ai/wisepipe-serialize';
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { runConfigSchemaValidation } from '../validations.generated';
export const runConfigSchema = {
    $id: 'urn:wisepipe-common-computation:RunConfig',
    type: 'object',
    properties: {
        type: { type: 'string', enum: Object.values(ToolType) }
    },
    required: ['type']
};
// These are run-specific configs for tools, they are serialized and passed into the transformers, ie in export.py you will see the exportRunConfig passed in
/*
        if 'run_config' in X and X['run_config'] is not None:
            col_name_to_filter_vals = X['run_config'].get('colValFilterMap', {})
            key_cols = X['run_config'].get('keyColumns', [])
*/
let RunConfig = RunConfig_1 = class RunConfig {
    constructor(type) {
        this.type = type;
        JSON.validate(this, RunConfig_1);
    }
};
RunConfig = RunConfig_1 = __decorate([
    JsonSchemaV2(runConfigSchema, runConfigSchemaValidation),
    JsonDiscriminatorProperty('type')
], RunConfig);
export { RunConfig };
//# sourceMappingURL=runConfig.js.map